import universalComponent, {
  ComponentType,
  UniversalComponent,
  Module as _Module,
} from 'react-universal-component';
import { captureException } from '@sentry/browser';
import { DEBUG } from '../../ReduxStorage/location/constants';

export const defaultSettings = {
  loading: () => null,
  timeout: 30000, // 30 second timeout for code loading
  ignoreBabelRename: true,
  onError: (error: Error) => {
    // eslint-disable-next-line no-console
    console.error(error);

    if (DEBUG) {
      captureException(error);
    }
  },
};

type ImportExprType<P, T> = (props: P) => PromiseLike<T>;

export type Module<C> = _Module<C>;

export const universal = <
  P,
  C extends ComponentType<P> = ComponentType<P>,
  Export extends _Module<C> = _Module<C>
>(
  importExpr: ImportExprType<P, Export>,
  settings = {}
): UniversalComponent<P> =>
  universalComponent(importExpr, { ...defaultSettings, ...settings });
